// A REGRA DA CLASSIFICACAO DE UMA RUBRICA (#270, ADR-0015).
//
// Uma funcao so', pura, que a API usa para recusar (400) e as duas telas usam
// para travar o Salvar e dizer o que falta. Antes, cada tela tinha a sua versao
// — o modal do motor e o cartao da conciliacao divergiam em quem podia cadastrar
// consignataria —, e a API descartava em silencio o que a tela mandava errado
// (produto de facultativa, credor de provento). O banco nao recusa nada disto:
// os CHECKs da 0059 so' cobrem valor fora da lista. A regra mora aqui.
//
// O que ela garante:
//   - credito e facultativa tem tipo de servico, e o tipo e' da categoria;
//   - facultativa nao tem produto: o destino dela e' da regra de margem do ente
//     (#271), nao da rubrica;
//   - provento, desconto obrigatorio e desconto nao consignado nao tem credor,
//     tipo, produto nem credor final;
//   - credor final e' "via" uma consignataria — sem ela nao existe, e nao e' ela
//     mesma.
import { categoriaDoTipo, ehCategoriaComCredor, ehTipoServico, ROTULO_CATEGORIA_LEGAL, } from "./tipo-servico.js";
export function validarClassificacao(c, { exigeTipo }) {
    const erros = {};
    if (c.categoria === "nao_classificada") {
        erros.categoria = "escolha a categoria legal";
        return erros;
    }
    if (c.compoeBaseMargem === false && c.categoria !== "provento") {
        erros.compoeBaseMargem = "só provento fica fora da base da margem";
    }
    if (!ehCategoriaComCredor(c.categoria)) {
        // Provento, desconto obrigatorio, desconto nao consignado: nada de consignacao.
        const nome = ROTULO_CATEGORIA_LEGAL[c.categoria].toLowerCase();
        if (c.tipoServico !== null)
            erros.tipoServico = `${nome} não tem tipo de serviço`;
        if (c.produto !== null)
            erros.produto = `${nome} não ocupa produto de margem`;
        if (c.consignatariaId !== null)
            erros.consignatariaId = `${nome} não tem consignatária`;
        if (c.credorFinalId !== null)
            erros.credorFinalId = `${nome} não tem credor final`;
        return erros;
    }
    if (c.tipoServico === null) {
        if (exigeTipo)
            erros.tipoServico = "escolha o tipo de serviço";
    }
    else if (!ehTipoServico(c.tipoServico)) {
        erros.tipoServico = `tipo de serviço desconhecido: ${c.tipoServico}`;
    }
    else if (categoriaDoTipo(c.tipoServico) !== c.categoria) {
        const doTipo = ROTULO_CATEGORIA_LEGAL[categoriaDoTipo(c.tipoServico)].toLowerCase();
        erros.tipoServico = `este tipo de serviço é de ${doTipo}`;
    }
    if (c.categoria === "consignacao_facultativa" && c.produto !== null) {
        erros.produto = "o destino da facultativa é da regra de margem do órgão, não da rubrica";
    }
    if (c.credorFinalId !== null) {
        if (c.consignatariaId === null)
            erros.credorFinalId = "credor final exige a consignatária de repasse";
        else if (c.credorFinalId === c.consignatariaId)
            erros.credorFinalId = "o credor final é outro, não a própria consignatária";
    }
    return erros;
}
//# sourceMappingURL=classificacao-rubrica.js.map